import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="512px"
      height="512px"
      viewBox="0 0 512 512"
      fill={fill}
    >
      <g>
        <path
          d="M464,64v416H80c-17.672,0-32-14.312-32-32s14.328-32,32-32h352V0H80C44.656,0,16,28.656,16,64v384
            c0,35.344,28.656,64,64,64h416V64H464z"
        />
      </g>
    </svg>
  );
};

export default memo(Icon);
